import { render } from "./DocTax.vue?vue&type=template&id=74e787cf"
import script from "./DocTax.vue?vue&type=script&lang=js"
export * from "./DocTax.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__